import { useCallDataExtractionLayout } from 'app/components/call-data-extraction-layout/useCallDataExtractionLayout'
import { CallDataExtractionLayoutShadcnComponent } from 'app/components/call-data-extraction-layout/CallDataExtractionLayoutShadcnComponent'

export const handle = {
  title: `Call Data Extraction`,
  breadcrumb: `Call Data Extraction`,
}

export default function CallDataExtractionRoute(): React.ReactElement {
  const { children } = useCallDataExtractionLayout()
  return <CallDataExtractionLayoutShadcnComponent>{children}</CallDataExtractionLayoutShadcnComponent>
}
